import { memo } from 'react';
import {
  Button as ButtonParallax,
  type ButtonProps,
} from '@adc/parallax-component-library';

export const Button = memo(({ testID, disabled, ...rest }: ButtonProps) => {
  return (
    <ButtonParallax
      testID={disabled ? `${testID}-disabled` : `${testID}`}
      disabled={disabled}
      {...rest}
    />
  );
});

Button.displayName = 'Button';
